import { useState } from "react";
import ListItem from "@mui/material/ListItem";
import { Button } from "@mui/material";
import { useIsAdmin } from "utils/customHooks/genericHooks";
import { TextField } from "@mui/material";
import {
  ASKR_CUSTOM_URL_LS_KEY,
  ASKR_INGESTR_CUSTOM_URL_LS_KEY,
  MIDGARD_CUSTOM_URL_LS_KEY,
} from "App/CustomAskrUrlIndicator";
import { SPACE_BETWEEN } from "constants/constants";

const ASKR_CUSTOM_URL_DEFAULT = "http://localhost:4000/graphql";
const ASKR_INGESTR_CUSTOM_URL_DEFAULT = "http://localhost:5000/graphql";
const MIDGARD_CUSTOM_URL_DEFAULT = "http://localhost:8080/graphql";

export function CustomAskrEndpointListItem() {
  const [hasBeenEdited, setHasBeenEdited] = useState(false);
  const isAdminUser = useIsAdmin();

  const [askrUrl, setAskrUrl] = useState(
    window.localStorage.getItem(ASKR_CUSTOM_URL_LS_KEY) || ""
  );
  const [askrIngestrUrl, setAskrIngestrUrl] = useState(
    window.localStorage.getItem(ASKR_INGESTR_CUSTOM_URL_LS_KEY) || ""
  );
  const [midgardUrl, setMidgardUrl] = useState(
    window.localStorage.getItem(MIDGARD_CUSTOM_URL_LS_KEY) || ""
  );
  const badCombo = (askrUrl && !askrIngestrUrl) || (!askrUrl && askrIngestrUrl);
  return !isAdminUser ? null : (
    <>
      <ListItem
        className="customAskrUrl"
        style={{
          display: "flex",
          justifyContent: SPACE_BETWEEN,
          maxWidth: 540,
        }}
      >
        <div className="label">Askr: custom endpoint url</div>
        <div
          style={{
            minWidth: 102,
          }}
        >
          <TextField
            placeholder={ASKR_CUSTOM_URL_DEFAULT}
            value={askrUrl}
            onChange={event => {
              window.localStorage.setItem(
                ASKR_CUSTOM_URL_LS_KEY,
                event.target.value
              );
              setAskrUrl(event.target.value);
              setHasBeenEdited(true);
            }}
            onClick={() => {
              // if it's empty, populate with the placeholder value
              if (!window.localStorage.getItem(ASKR_CUSTOM_URL_LS_KEY)) {
                window.localStorage.setItem(
                  ASKR_CUSTOM_URL_LS_KEY,
                  ASKR_CUSTOM_URL_DEFAULT
                );
                setAskrUrl(ASKR_CUSTOM_URL_DEFAULT);
                setHasBeenEdited(true);
              }
            }}
            error={Boolean(hasBeenEdited && badCombo)}
            helperText={
              !hasBeenEdited || !askrUrl
                ? ""
                : badCombo
                  ? "both Askr endpoint fields must be populated"
                  : "Reload the page to apply these changes"
            }
          />
        </div>
      </ListItem>
      <ListItem
        className="customAskrIngestrUrl"
        style={{
          display: "flex",
          justifyContent: SPACE_BETWEEN,
          maxWidth: 540,
        }}
      >
        <div className="label">Askr Ingestr: custom endpoint url</div>
        <div
          style={{
            minWidth: 102,
          }}
        >
          <TextField
            placeholder={ASKR_INGESTR_CUSTOM_URL_DEFAULT}
            value={askrIngestrUrl}
            onChange={event => {
              window.localStorage.setItem(
                ASKR_INGESTR_CUSTOM_URL_LS_KEY,
                event.target.value
              );
              setAskrIngestrUrl(event.target.value);
              setHasBeenEdited(true);
            }}
            onClick={() => {
              // if it's empty, populate with the placeholder value
              if (
                !window.localStorage.getItem(ASKR_INGESTR_CUSTOM_URL_LS_KEY)
              ) {
                window.localStorage.setItem(
                  ASKR_INGESTR_CUSTOM_URL_LS_KEY,
                  ASKR_INGESTR_CUSTOM_URL_DEFAULT
                );
                setAskrIngestrUrl(ASKR_INGESTR_CUSTOM_URL_DEFAULT);
                setHasBeenEdited(true);
              }
            }}
            error={Boolean(hasBeenEdited && badCombo)}
            helperText={
              !hasBeenEdited || !askrIngestrUrl
                ? ""
                : badCombo
                  ? "both Askr endpoint fields must be populated"
                  : "Reload the page to apply these changes"
            }
          />
        </div>
      </ListItem>
      <ListItem
        className="customAskrIngestrUrl"
        style={{
          display: "flex",
          justifyContent: SPACE_BETWEEN,
        }}
      >
        <div className="label">Midgard: custom endpoint url</div>
        <div
          style={{
            minWidth: 102,
          }}
        >
          <TextField
            placeholder={MIDGARD_CUSTOM_URL_DEFAULT}
            value={midgardUrl}
            onChange={event => {
              window.localStorage.setItem(
                MIDGARD_CUSTOM_URL_LS_KEY,
                event.target.value
              );
              setMidgardUrl(event.target.value);
              setHasBeenEdited(true);
            }}
            onClick={() => {
              // if it's empty, populate with the placeholder value
              if (!window.localStorage.getItem(MIDGARD_CUSTOM_URL_LS_KEY)) {
                window.localStorage.setItem(
                  MIDGARD_CUSTOM_URL_LS_KEY,
                  MIDGARD_CUSTOM_URL_DEFAULT
                );
                setMidgardUrl(MIDGARD_CUSTOM_URL_DEFAULT);
                setHasBeenEdited(true);
              }
            }}
            helperText={
              hasBeenEdited && midgardUrl
                ? "Reload the page to apply these changes"
                : ""
            }
          />
          <Button
            disabled={Boolean(!hasBeenEdited || badCombo)}
            style={{ marginLeft: 10, marginTop: -64 }}
            onClick={() => window.location.reload()}
          >
            Apply & Reload
          </Button>
        </div>
      </ListItem>
    </>
  );
}
